module.exports = __webpack_public_path__ + "res/ic_guess_result.2ee92766aef02e0dda7dd42a89482ac7.png";